import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Publisher} from '../shared/domain/publisher.model';
import {AuthService} from '../shared/auth/auth.service';
@Injectable()
export class PublisherResolver implements Resolve<Publisher> {
  constructor(private authService: AuthService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const publisherIdentity = this.authService.publisherIdentity();
    publisherIdentity.subscribe(()=>{

    }, ()=>{
      console.log('yes')
    })
    return publisherIdentity;
  }
}
